import React from 'react';
import { useEditorUI } from '../../../context/EditorUIContext';
import { useCanvas } from '../../../context/CanvasContext';
import styles from './styles/EditSidebarTabs.module.css';
import { TUTORIAL_TARGETS, tutorialAttr } from '../../../tutorials';
import { FaKey } from 'react-icons/fa';
import { edgeKeyRoles, nodeKeyRoles } from './keys/keyGraph';

const typeLabelMap = {
    situation: 'Editing Situation',
    choice: 'Editing Choice',
    group: 'Editing Group',
};

const EditSidebarTabs = ({ editType }) => {
    const { activeEditTab, setActiveEditTab, selectedNodeId, selectedEdgeId } = useEditorUI();
    const { getNode, getEdge } = useCanvas();

    // Whether the Keys tab has anything set, so it can say so without being opened.
    let usesKeys = false;
    if (editType === 'situation' && selectedNodeId) {
        const roles = nodeKeyRoles(getNode(selectedNodeId)?.data);
        usesKeys = roles.grants || roles.removes;
    } else if (editType === 'choice' && selectedEdgeId) {
        const roles = edgeKeyRoles(getEdge(selectedEdgeId)?.data);
        usesKeys = roles.grants || roles.removes || !!roles.gate;
    }

    const handleTabClick = (tab) => {
        setActiveEditTab(tab);
    };

    const getTabLabel = (tab) => {
        switch (tab) {
            case '1':
                return 'Content';
            case '2':
                if (editType === 'situation') return 'Choices';
                if (editType === 'choice') return 'Link';
                if (editType === 'group') return 'Situations';
                return '';
            case '3':
                return 'Settings';
            case '4':
                return 'Keys';
            default:
                return '';
        }
    };

    const tabs = ['1', '2', '3'];


    if (editType === 'situation' || editType === 'choice') {
        tabs.push('4');
    }

    return (
        <div className={styles.tabsWrapper}>
            <div className={styles.typeIndicator}>
                <span className={styles.typeBadge}>{editType}</span>
                <span className={styles.typeLabel}>{typeLabelMap[editType]}</span>
            </div>
            <div className={styles.tabsContainer}>
                {tabs.map((tab) => (
                    <div
                        key={tab}
                        className={`${styles.tab} ${
                            activeEditTab === tab ? styles.activeTab : ''
                        }`}
                        onClick={() => handleTabClick(tab)}
                        {...tutorialAttr(TUTORIAL_TARGETS.EDIT_TAB, tab)}
                    >
                        {getTabLabel(tab)}
                        {tab === '4' && usesKeys && (
                            <FaKey
                                size={10}
                                title="This has key settings"
                                style={{ marginLeft: '0.3rem', verticalAlign: 'middle' }}
                            />
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default EditSidebarTabs;
